import { Box } from '@deity/falcon-ui';
import type { IconType } from '@deity-io/portal-ui';
import { Icon } from '@deity-io/portal-ui';
import type { FC } from 'react';

interface IFoldedPanelProps {
  panel: { title: string; panelKey: string; component: JSX.Element; icon?: IconType; disabled?: boolean };
  openPanel: (panel: string) => void;
}

const FoldedPanel: FC<IFoldedPanelProps> = ({ panel, openPanel }) => {
  const hoverHandler = e => {
    e.target.style.borderStyle = 'solid';
  };
  const outHandler = e => {
    e.target.style.borderStyle = 'none';
  };

  return (
    <Box
      key={`Folded_${panel.panelKey}`}
      style={{
        display: 'inline',
        paddingTop: '10px',
        cursor: 'pointer',
        borderColor: 'black',
        borderStyle: 'none',
        borderWidth: '1px',
        color: panel.disabled ? 'grey' : 'black'
      }}
      onClick={() => {
        openPanel(panel.panelKey);
      }}
      onMouseOver={hoverHandler}
      onFocus={hoverHandler}
      onMouseOut={outHandler}
      onBlur={outHandler}
      role="button"
      tabIndex={0}
    >
      {panel.icon && <Icon key={`ICON_${panel.panelKey}`} style={{ borderWidth: '0px' }} icon={panel.icon} />}
      {panel.title}
    </Box>
  );
};

export default FoldedPanel;
